<template>
  <div class="gc-text-content">
    <h3 :class="{'gc-title': true, 'locked': blurLock, 'locked-title': blurLock}">{{ title }}</h3>
    <p :class="{locked: blurLock}" v-html="text" />
  </div>
</template>

<script>
export default {
  name: 'GoalCardText',
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    blurLock: {
      type: Boolean,
      required: false
    }
  }
}
</script>

<style lang="less" scoped>
@import './colors.less';

h3 {
  color: @titleColor;
  font-size: 18px;
  line-height: 20px;
  margin: 0 0 0.7em 0;
  max-height: 40px;
  overflow: hidden;
}

p {
  color: @textPrimary;
  font-size: var(--text-md);

}
.locked {
  color: transparent;
}
.locked-title {
  color: transparent;
  max-height: fit-content;
  padding: 0.5rem;
}
</style>
